import { routes } from './app-routes';

function compareIndex(a, b) {
  if (a.index > b.index) return 1;
  if (b.index > a.index) return -1;
  return 0;
}

export const getNavigationItems = () => {
  let navigationItems = [];
  
  for (let k in routes) {
    let route = routes[k];

    navigationItems.push({
      index: route.index,
      text: route.text,
      icon: route.icon,
      path: k,
      enabled: true,
      component: route.component
    });
  }

  // Sort by index
  return navigationItems.sort(compareIndex);
};

export const getMenuItems = (callaback) => {

  let userMenuItems = [];

  for (let k in routes) {
    let route = routes[k];
    if (!route.showInMenuDropdown)
      continue; // Skip if not a menu item

    userMenuItems.push({
      index: route.index,
      text: route.text,
      icon: route.icon,
      path: k,
      divide: false,
      onClick: callaback
    });
  }

  // Sort by index
  userMenuItems = userMenuItems.sort(compareIndex);

  // Add logout button
  userMenuItems.push({
    text: 'Logout',
    icon: 'runner',
    divide: true,
    path: '/logout',
    onClick: callaback
  });
  
  return userMenuItems;
}